/** Offline emergency cards — nearest A&E + site arrangements per job, kept in localStorage so the static
 *  /emergency-card.html page (precached by the service worker) can show them with no signal on site. */
const KEY = "fixlr.emergencyCards";
const MAX = 8;

export function loadEmergencyCards() {
  try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; }
}

export function getEmergencyCard(ramsId) {
  return loadEmergencyCards().find((c) => c.ramsId === ramsId) || null;
}

export function saveEmergencyCard(card) {
  try {
    const rest = loadEmergencyCards().filter((c) => c.ramsId !== card.ramsId);
    const next = [{ ...card, cachedAt: new Date().toISOString() }, ...rest].slice(0, MAX);
    localStorage.setItem(KEY, JSON.stringify(next));
    return true;
  } catch {
    try { // quota — drop the map images of older cards and retry once
      const rest = loadEmergencyCards().filter((c) => c.ramsId !== card.ramsId).map((c) => ({ ...c, mapDataUrl: "" }));
      localStorage.setItem(KEY, JSON.stringify([{ ...card, cachedAt: new Date().toISOString() }, ...rest].slice(0, MAX)));
      return true;
    } catch { return false; }
  }
}

export function blobToDataUrl(blob) {
  return new Promise((resolve) => {
    const r = new FileReader();
    r.onloadend = () => resolve(typeof r.result === "string" ? r.result : "");
    r.onerror = () => resolve("");
    r.readAsDataURL(blob);
  });
}

export const EMERGENCY_CARD_URL = "/emergency-card.html";
